<script setup>
const cms = useCms()
const common = cms.value?.common

const route = useRoute()

const languageStore = useLanguage()
const screenType = useScreenType()

const step = computed(() => {
  if (route?.name == 'detail') {
    return 1
  } else {
    return 2
  }
})
</script>

<template>
  <div class="w-full px-4">
    <div class="max-w-[1440px] mx-auto bg-ui-colourful-100">
      <div class="py-3 mobile:px-0 flex w-full items-center gap-x-3 px-3">
        <div
          class="text-main-tertiary font-semibold text-sm whitespace-nowrap flex items-center gap-x-2"
        >
          <span
            class="w-5 h-5 border-main-secondary border-[3px] rounded-full grid place-content-center"
          >
            <i class="icon-check text-base"></i>
          </span>
          <div class="mobile:hidden" cms-key="progress_text1">
            {{ common?.progress_text1 }}
          </div>
        </div>
        <div class="border-t w-full border-main-secondary"></div>
        <div
          class="text-main-tertiary font-semibold text-sm whitespace-nowrap flex gap-x-2 items-center"
        >
          <span
            class="w-5 h-5 border-main-secondary rounded-full grid place-content-center"
            :class="step == 1 ? 'border-[2px]' : 'border-[3px]'"
          >
            <i :class="step == 2 && 'icon-check text-base'"></i>
          </span>

          <div :class="step == 2 && 'mobile:hidden'" cms-key="progress_text2">
            {{ common?.progress_text2 }}
          </div>
        </div>
        <div
          class="border-t w-full"
          :class="
            step == 1
              ? 'border-light-gray border-dashed'
              : 'border-main-secondary'
          "
        ></div>
        <div
          class="font-semibold text-sm whitespace-nowrap flex gap-x-2 items-center"
          :class="step == 1 ? ' text-light-gray' : 'text-main-tertiary'"
        >
          <span
            class="w-5 h-5 rounded-full grid place-content-center border-[2px]"
            :class="step == 1 ? ' border-light-gray' : 'border-main-secondary'"
          >
          </span>

          <div :class="step == 1 && 'mobile:hidden'" cms-key="progress_text3">
            {{ common?.progress_text3 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
